import { parseISO } from 'date-fns';
import { isStartDateAfterTargetDate } from '@acorn-portal/shared/src/utils';
import { KeyCareUnderwriter } from '@acorn-portal/shared/src/services/interface/Shared';
import {
	LEGAL_COVER_MODAL,
	WINDSCREEN_COVER_MODAL,
	KEYCARE_COVER_MODAL,
	FLAG_TAXI_REPLACEMENT_HIRE,
	TAXI_REPLACEMENT_HIRE,
	KEY_CARE_MOTORCADE,
	KEY_CARE_CARROT,
	KEY_CARE_FLAG,
	KEY_CARE_STREETCOVER,
	KEY_CARE,
	PUBLIC_LIABILITY_COVER_UP_10M_FLAG,
	PUBLIC_LIABILITY_COVER_UP_10M,
	PUBLIC_LIABILITY_COVER_UP_5M_FLAG,
	PUBLIC_LIABILITY_COVER_UP_5M,
	PUBLIC_LIABILITY_COVER_UP_5M_SHORT_TERM,
} from '@acorn-portal/shared/src/utils/modalText';

const getAdditionalExtraText = (addon: string, product?: string, policyStartDate?: string) => {
	const keycareUnderwriter =
		policyStartDate && isStartDateAfterTargetDate(parseISO(policyStartDate), parseISO('2024-09-01'))
			? KeyCareUnderwriter.AA
			: KeyCareUnderwriter.AGEAS;

	switch (addon) {
		case 'Legal Expenses':
			return LEGAL_COVER_MODAL.text;
		case 'Audio Equipment':
			return 'Audio Equipment Cover';
		case 'Windscreen':
			return WINDSCREEN_COVER_MODAL.text;
		case 'Loss of Keys': {
			return KEYCARE_COVER_MODAL(keycareUnderwriter).text;
		}
		case 'Taxi Replacement Hire': {
			if (product?.includes('Flag')) {
				return FLAG_TAXI_REPLACEMENT_HIRE.text;
			} else {
				return TAXI_REPLACEMENT_HIRE.text;
			}
		}
		case 'Keycare':
			if (product?.includes('Motorcade')) {
				return KEY_CARE_MOTORCADE(keycareUnderwriter).text;
			} else if (product?.includes('Carrot')) {
				return KEY_CARE_CARROT(keycareUnderwriter).text;
			} else if (product?.includes('Flag')) {
				return KEY_CARE_FLAG(keycareUnderwriter).text;
			} else if (product?.includes('StreetCover')) {
				return KEY_CARE_STREETCOVER(keycareUnderwriter).text;
			} else {
				return KEY_CARE(keycareUnderwriter).text;
			}
		case 'Public Liability £10m': {
			if (product?.includes('Flag')) {
				return PUBLIC_LIABILITY_COVER_UP_10M_FLAG.text;
			} else {
				return PUBLIC_LIABILITY_COVER_UP_10M.text;
			}
		}
		case 'Public Liability £5m - 7 Passengers': {
			if (product?.includes('Flag')) {
				return PUBLIC_LIABILITY_COVER_UP_5M_FLAG.text;
			} else {
				return PUBLIC_LIABILITY_COVER_UP_5M.text;
			}
		}
		case 'Public Liability £5m': {
			return PUBLIC_LIABILITY_COVER_UP_5M_SHORT_TERM.text;
		}
		default:
			return '';
	}
};

export default getAdditionalExtraText;
